import { useEffect } from "react";

import { useCurrentUser } from "../../hooks";
import posthog from "../../utils/posthog";

function PosthogIdentify() {
    const [user] = useCurrentUser();
    const distinctId = user?.id ?? user?.userName;

    useEffect(() => {
        if (distinctId) {
            posthog.identify(distinctId, {
                username: user.userName,
                email: user.email,
                account_type: user.account_type,
            });
        } else {
            posthog.reset();
        }
    }, [distinctId]);

    return null;
}

export default PosthogIdentify;
